import React, { useState, useEffect } from 'react';
import { CategoryFormModalProps } from '../../types/category';
import styles from './CategoryFormModal.module.css';

const CategoryFormModal: React.FC<CategoryFormModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  initialData,
  isLoading = false,
}) => {
  const [name, setName] = useState('');
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    if (initialData) {
      setName(initialData.name || initialData.category_name || '');
      setImageUrl(initialData.image_url || '');
    } else {
      setName('');
      setImageUrl('');
    }
  }, [initialData, isOpen]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit({ name, image_url: imageUrl || null });
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImageUrl(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = () => {
    setImageUrl('');
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3>{initialData ? 'Edit Category' : 'Add New Category'}</h3>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label htmlFor="categoryName">Name *</label>
            <input
              type="text"
              id="categoryName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="categoryImage">Image</label>
            <input
              type="file"
              id="categoryImage"
              accept="image/*"
              onChange={handleImageChange}
              disabled={isLoading}
            />
          </div>

          {imageUrl && (
            <div className={styles.imagePreview}>
              <img src={imageUrl} alt="Category preview" className={styles.previewImage} />
              <button 
                type="button" 
                onClick={removeImage} 
                className={styles.removeImageButton}
                disabled={isLoading}
              >
                Remove Image
              </button>
            </div>
          )}

          <div className={styles.formActions}>
            <button type="submit" className={styles.submitButton} disabled={isLoading}>
              {isLoading ? 'Saving...' : (initialData ? 'Save Changes' : 'Add Category')}
            </button>
            <button type="button" onClick={onClose} className={styles.cancelButton} disabled={isLoading}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryFormModal; 